import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import Section_name from "./Section_name";
import { useRouter } from "next/router";

const Platforms = () => {
  const t = useTranslations("ipillion.Platforms");
  const router = useRouter();
  const [lang, setLang] = useState(router.locale);
  useEffect(() => {
    setLang(router.locale);
  }, [router.locale]);

  return (
    <div className="bg-[#1D1D1B] bg-opacity-[2%] py-5 my-5">
      <div className="relative  responsive max-w-[90rem] m-auto">
        <Section_name
          name={t("header")}
          color={"#D60014"}
          margian={"mt-[128px] mb-[80px]"}
        />
        <div className="relative grid grid-cols-12 gap-[10px] gap-y-20 max-w-[90rem] ">
          <div className="xlg:col-span-6 col-span-12 grid grid-cols-12 ">
            <div className="relative xlg:col-span-6 col-span-12  ">
              <Image
                src="/ipillion/laptop.png"
                layout="responsive"
                width={517}
                height={345}
              />
            </div>
            <div className="xlg:col-span-6 md:col-span-6 col-span-12">
              <div>
                <p
                  className={`text-[#D60014] left-0 font-[700] lg:mt-0 mt-1 mb-5 text-[80px] leading-[56px] opacity-[0.3] ${
                    lang == "ar" ? "pb-5" : null
                  }`}
                >
                  {t("title1")}
                </p>
              </div>
              <p className="max-w-[295px] font-[400] text-[18px] leading-[26px]">
                {t("descrption1")}
              </p>
            </div>
          </div>
          <div className="xlg:col-span-6 col-span-12 grid grid-cols-12 ">
            <div className="relative  xlg:col-span-6 col-span-12">
              <Image
                src="/ipillion/laptop2.png"
                layout="responsive"
                width={517}
                height={345}
              />
            </div>
            <div className="xlg:col-span-6 md:col-span-6 col-span-12">
              <div>
                <p
                  className={`text-[#D60014] left-0 font-[700] lg:mt-0 mt-1 mb-5 text-[80px] leading-[56px] opacity-[0.3] ${
                    lang == "ar" ? "pb-5" : null
                  }`}
                >
                  {t("title2")}
                </p>
              </div>
              <p className="max-w-[295px] font-[400] text-[18px] leading-[26px]">
                {t("descrption2")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Platforms;
// font-weight: 400;
// font-size: 18px;
// line-height: 26px;
